import { gql } from "apollo-angular";

export default gql`
  query search($search: String, $page: Int = 1) {
    feedsGraphql(search: $search, page: $page) {
      count
      entities {
        blogs {
          nid
          title,
          path
        }
        advisories {
          nid
          title
          path
        }
        totalPages
      }
    }
  }
`;
